import styled from 'styled-components';

export const PageWrapper = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-direction: column;
  height: 100%;
  background-color: ${props => props.$backgroundColor || 'transparent'};
`;
